export default Object.freeze({
    USER: 'user',
    COMPANY: 'company',
})
